import { Component, Input, OnChanges, SimpleChange, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from 'src/app/core/services/settings.service';
import { Entity } from 'src/app/core/models/entity.model';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { Settings360Depict } from 'src/app/core/models/settings.model';
import { PreviewExternalSettingsComponent } from 'src/app/core/components/preview-external-settings/preview-external-settings.component';
import { EntityService } from 'src/app/core/services/entity.service';
import { FileSpecsService } from 'src/app/core/services/file-specs.service';

@Component({
  selector: 'hbo-setting-360',
  templateUrl: './setting-360.component.html',
  styleUrls: ['./setting-360.component.scss']
})
export class Setting360Component implements OnChanges {

  @Input() entity!: Entity;
  @Input() isOpen = false;

  @ViewChild('externalSettings') externalSettings!: PreviewExternalSettingsComponent;

  public utils = utils;

  showSettings = false;
  currentSettings?: Settings360Depict;
  hierarchy!: any;

  user: User = utils?.localStorageGetItem('user');

  settingsForm = this.formBuilder.nonNullable.group({
    language: ['es'],
    // 360Depict
    "360AppName": ['360Depict'],
    logoC: [''],
    technologies: this.formBuilder.group({
      // fit
      boxIA: [false],
      // 360Depict
      thinmaxPositive: [false],
      thinmaxPositiveName: ['Name'],

      thinmaxNegative: [false],
      thinmaxNegativeName: ['Name'],

      highPrescriptions: [false],
      highPrescriptionsName: ['Name'],

      extremePrescriptions: [false],
      extremePrescriptionsName: ['Name'],

      curvedStyle: [false],
      curvedStyleName: ['Name'],
    }),
  });

  constructor(
    private formBuilder: FormBuilder,
    private settingsService: SettingsService,
    private entityService: EntityService,
    private fileSpecsService: FileSpecsService
  ) { }

  ngOnChanges(changes: { [property: string]: SimpleChange }) {
    if (changes['isOpen']?.currentValue) {
      this.showSettings = false;
      this.setSettingsAncestor().then(res => {
        this.hierarchy = res.base64;
        this.settingsService.getThickness(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId).subscribe(
          res => {
            this.showSettings = true;
            this.setForm(res)
          },
          err => {
            if (err.status == 404) {
              this.settingsService.updateThickness(this.entity.internalCode ? this.entity.internalCode : this.entity.id, this.hierarchy, this.entity.entityTypeId, { "settings": { "timezone": this.entity.timezone } }).subscribe(
                res => {
                  this.settingsService.getThickness(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId).subscribe(
                    res => {
                      this.showSettings = true;
                      this.setForm(res)
                    },
                    err => {
                      console.log("errorrrr", err);
                      console.log(err.status)
                      this.showSettings = true;
                      this.setForm(this.initSettings360Depict())
                    }
                  )
                },
                err => {
                  console.log("errorrrr", err);
                  console.log(err.status)
                  this.showSettings = true;
                  this.setForm(this.initSettings360Depict())
                }
              )
            }else{
              console.log("errorrrr", err);
              console.log(err.status)
              this.showSettings = true;
              this.setForm(this.initSettings360Depict())
            }
          }
        );
      })
    }
  }

  getTouchedValues(form: any) {
    let touchedValues: { [key: string | number]: any } = {};

    Object.keys(form.controls)
      .forEach(key => {
        let currentControl = form.controls[key];

        if (currentControl.touched) {
          if (currentControl.controls)
            touchedValues[key] = this.getTouchedValues(currentControl);
          else
            touchedValues[key] = currentControl.value;
        }
      });

    return touchedValues;
  }

  setSettingsAncestor(): Promise<{ data: any; base64: string }> {
    return new Promise((resolve, reject) => {
      this.entityService.getAncestor(this.entity).subscribe(
        async res => {
          let parentEntity = res.parentEntity;
          let object = {
            "hierarchy": {
              "shop_id": String(this.entity.internalCode ? this.entity.internalCode : this.entity.id),
              "ancestor": this.entity?.entityTypeId != 1
                ? {
                  "shop_id": String(parentEntity?.internalCode ? parentEntity?.internalCode : parentEntity?.id),
                  "ancestor": this.entity?.entityTypeId != 2
                    ? {
                      "shop_id": String(parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.id),
                      "ancestor": parentEntity?.parentEntity?.entityTypeId == 2
                        ? {
                          "shop_id": String(parentEntity?.parentEntity?.parentEntity?.internalCode ? parentEntity?.parentEntity?.parentEntity?.internalCode : parentEntity?.parentEntity?.parentEntity?.id),
                          "ancestor": null
                        }
                        : null
                    }
                    : null
                }
                : null
            }
          }
          resolve({ data: object, base64: utils.objectToBase64(object) });
          //resolve({ data: object, base64: utils.objectToBase64(object) });
        });
    });
  }

  async preview() {
    this.externalSettings.showPreview({
      app: '360Depict',
      logoC: this.settingsForm.get('logoC')?.value ? await utils.toBase64('logoC', this.entity.id) : this.currentSettings?.appFrontendDesign?.['360Depict']?.logoImage!,
      depictName: this.settingsForm.value['360AppName']!
    })
  }

  async uploadFile(event: Event, _name: string) {
    const element = event.currentTarget as HTMLInputElement;
    let fileList: FileList | null = element.files;

    if (!fileList || fileList.length === 0) return;

    const file = fileList[0];
    const control = this.settingsForm.get(_name);

    if (!control) return;

    // Validar con el servicio centralizado
    if (!this.fileSpecsService.validateAndSetFormControl(_name, file, control, element)) {
      return;
    }

    let idObject: string | number = '';
    idObject = _name;

    if (idObject == 'logoC' && this.currentSettings?.appFrontendDesign?.['360Depict']) {
      this.currentSettings.appFrontendDesign['360Depict'].logoImage = await utils.toBase64(_name, this.entity.id);
      this.currentSettings.appFrontendDesign['360Depict'].logoName = _name;
    }
  }

  cleanParams(originalParams: any) {
    const cleanProps: any = {};
    // Recorrer las propiedades del objeto original para copiarlas al nuevo objeto
    for (const key in originalParams) {
      // Solo copiar la propiedad si tiene valor
      if (originalParams[key] || originalParams[key] === false || originalParams[key] === "") {
        if (typeof originalParams[key] === 'object' && !(originalParams[key] instanceof Array)) {
          // Si la propiedad es un objeto se llama recursivamente a esta funcion con esta propiedad y se asigna el resultado
          const cleanProp: object = this.cleanParams(originalParams[key]);
          if (Object.keys(cleanProp).length) {
            cleanProps[key] = cleanProp;
          }
        } else {
          // Si la propiedad no es un objeto se asigna directamente
          cleanProps[key] = originalParams[key];
        }
      }
    }
    return cleanProps;
  }

  async submit() {
    const update: Settings360Depict = {
      language: this.settingsForm.value.language!,
      appFrontendDesign: {
        "360Depict": {
          logoImage: this.settingsForm.get('logoC')?.value
            ? (await utils.toBase64('logoC', this.entity.id)).split(',')[1]
            : (this.currentSettings?.appFrontendDesign?.['360Depict']?.logoImage?.split(',')[1]
              ? this.currentSettings?.appFrontendDesign?.['360Depict']?.logoImage?.split(',')[1]
              : ''),
          logoName: this.settingsForm.controls.logoC.value
            ? (this.settingsForm.controls.logoC.value as string).replace('C:\\fakepath\\', '')
            : this.currentSettings?.appFrontendDesign?.['360Depict']?.logoName ?? '',
          appName: this.settingsForm.value['360AppName']!
        }
      },
      technologies: {
        thinmaxPositive: {
          name: this.settingsForm.value.technologies!.thinmaxPositiveName!,
          enabled: this.settingsForm.value.technologies!.thinmaxPositive!
        },
        thinmaxNegative: {
          name: this.settingsForm.value.technologies!.thinmaxNegativeName!,
          enabled: this.settingsForm.value.technologies!.thinmaxNegative!
        },
        extremePrescriptions: {
          name: this.settingsForm.value.technologies!.extremePrescriptionsName!,
          enabled: this.settingsForm.value.technologies!.extremePrescriptions!
        },
        highPrescriptions: {
          name: this.settingsForm.value.technologies!.highPrescriptionsName!,
          enabled: this.settingsForm.value.technologies!.highPrescriptions!
        },
        curvedStyle: {
          name: this.settingsForm.value.technologies!.curvedStyleName!,
          enabled: this.settingsForm.value.technologies!.curvedStyle!
        },
      }
    }
    let touchedControls = this.getTouchedValues(this.settingsForm);
    let imagesTouched: string[] = ['logoC', 'technologies'];
    imagesTouched.map(image => {
      switch (image) {
        case 'logoC':
          if (touchedControls[image] === undefined) delete update.appFrontendDesign?.['360Depict']?.logoImage && delete update.appFrontendDesign?.['360Depict']?.logoName
          break;
        case 'technologies':
          if (touchedControls[image] === undefined) delete update.technologies
          break;
        default:
          break;
      }
    })
    if (this.entity.entityTypeId === 4) delete update.appFrontendDesign
    this.settingsService.updateThickness(this.entity.internalCode, this.hierarchy, this.entity.entityTypeId, { "settings": this.cleanParams(update) }).subscribe(res => {
      this.showSettings = true;
      // this.setForm(res["settings"]);
      // this.settingsService.getThickness(this.entity.internalCode, utils.objectToBase64({ shop_id: this.entity.internalCode, ancestor: { shop_id: this.entity.parentEntity?.internalCode, ancestor: null } })).subscribe(res => {
      // });
    })
  }

  setForm(res: Settings360Depict) {
    this.currentSettings = res;
    this.settingsForm.patchValue({
      language: res.language,
      "360AppName": res.appFrontendDesign?.['360Depict']?.appName,
      technologies: {
        thinmaxPositive: res.technologies?.thinmaxPositive?.enabled,
        thinmaxPositiveName: res.technologies?.thinmaxPositive?.name,

        thinmaxNegative: res.technologies?.thinmaxNegative?.enabled,
        thinmaxNegativeName: res.technologies?.thinmaxNegative?.name,

        highPrescriptions: res.technologies?.highPrescriptions?.enabled,
        highPrescriptionsName: res.technologies?.highPrescriptions?.name,

        extremePrescriptions: res.technologies?.extremePrescriptions?.enabled,
        extremePrescriptionsName: res.technologies?.extremePrescriptions?.name,

        curvedStyle: res.technologies?.curvedStyle?.enabled,
        curvedStyleName: res.technologies?.curvedStyle?.name,
      }
    })

    if (this.entity.id === this.user.entityId && this.user.profileId !== 3 && !(this.user.roleId === 4 && this.user.profileId === 1)) {
      this.settingsForm.disable();
    }
  }

  showImage(e: Event, _image?: string) {
    e.preventDefault();
    const image = new Image();
    image.src = _image!;
    image.style.maxWidth = '40%';
    image.style.margin = '20px';
    const w = window.open("", "_blank");
    w!.document.write(
      "<div style='background-color: #212121; width: 100%; height: 100%; margin: -8px;'>" + image.outerHTML + "</div>"
    );
  }

  clearImage(e: Event, image?: string) {
    e.preventDefault();
    this.settingsForm.get(image?.split('-')[0] as any)?.patchValue('');
    this.settingsForm.get(image?.split('-')[0] as any)?.markAsTouched({ onlySelf: true });
    (document.querySelector('#' + image) as HTMLInputElement).value = ''
    if (this.currentSettings?.appFrontendDesign?.['360Depict']) {
      this.currentSettings.appFrontendDesign['360Depict'].logoImage = '';
      this.currentSettings.appFrontendDesign['360Depict'].logoName = '';
    }
  }

  initSettings360Depict(): Settings360Depict {
    let settings360Depict = new Settings360Depict();
    settings360Depict = {
      language: '',
      appFrontendDesign: {
        "360Depict": {
          logoImage: '',
          logoName: '',
          appName: '',
        },
      },
      technologies: {
        thinmaxPositive: {
          name: '',
          enabled: false
        },
        thinmaxNegative: {
          name: '',
          enabled: false
        },
        extremePrescriptions: {
          name: '',
          enabled: false
        },
        highPrescriptions: {
          name: '',
          enabled: false
        },
        curvedStyle: {
          name: '',
          enabled: false
        }

      }
    }
    return settings360Depict
  }

}
